import { useState, useEffect, createContext, useContext } from 'react';
import { toast } from 'sonner';
import { API } from '../config/api';



const CoinContext = createContext(null);

export function CoinProvider({ children, getAuthHeaders, isAuthenticated }) {
  const [wallet, setWallet] = useState({ coin_balance: 0 });
  const [loading, setLoading] = useState(true);

  const fetchWallet = async () => {
    if (!isAuthenticated || !getAuthHeaders) return;
    
    try {
      const response = await fetch(`${API}/coins/wallet`, {
        headers: getAuthHeaders()
      });
      if (response.ok) {
        const data = await response.json();
        setWallet(data);
      }
    } catch (error) {
      console.error('Error fetching wallet:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchWallet();
    } else {
      setLoading(false);
    }
  }, [isAuthenticated]);

  const refreshWallet = () => fetchWallet();

  return (
    <CoinContext.Provider value={{ wallet, loading, refreshWallet }}>
      {children}
    </CoinContext.Provider>
  );
}

export function useCoins() {
  const context = useContext(CoinContext);
  if (!context) {
    return { wallet: { coin_balance: 0 }, loading: false, refreshWallet: () => {} };
  }
  return context;
}
